import React, { useCallback, type MouseEvent, type KeyboardEvent } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import { Link, type LinkProps } from '@atlassian/jira-router';

type Props = LinkProps & {
	innerFocusOutline?: boolean;
};

const TableCellLink = ({ onClick, ...rest }: Props) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const onClickWithAnalytics = useCallback(
		(e: MouseEvent | KeyboardEvent) => {
			fireUIAnalytics(
				createAnalyticsEvent({
					action: 'clicked',
					actionSubject: 'link',
				}),
				'tableIssueLink',
			);
			onClick && onClick(e);
		},
		[createAnalyticsEvent, onClick],
	);
	return <StyledLink {...rest} onClick={onClickWithAnalytics} />;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledLink = styled(Link)<{ innerFocusOutline?: boolean }>(
	{
		wordBreak: 'break-word',
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	({ innerFocusOutline }) =>
		innerFocusOutline && {
			'&:focus-visible': {
				outlineOffset: token('space.negative.025', '-2px'),
			},
		},
);

export default TableCellLink;
